import React from 'react';
import ConfigureLayout from '../../components/configure/ConfigureLayout';
import StreamContainer from '../../components/configure/streams/Stream';
const Streams = () => {
  return (
    <ConfigureLayout>
      <StreamContainer />
    </ConfigureLayout>
  );
};

export default Streams;
